export enum SubleaseType {
    NO_SUBLEASE = 'No Sublease',
    SUBLEASE_AS_OPERATE_LEASE = 'Sublease as Operate Lease'
}
